import React, { useEffect, useState } from "react";
import "./Cart.css";

import Step_1 from "./step_1/Step_1";
import Step_2 from "./step_2/Step_2";
import Step_2_1 from "./step_2/Step_2_1/Step_2_1";
import CartSteps from "./cartSteps/CartSteps";
import Step_3 from "./step_3/Step_3";
import { getAllPricesLuxury, getCartLuxury } from "../../utils/luxuryapis/addToCart/addToCart";
import { UserGet } from "../../utils/apis/myAccount/myAccount";

function Cart() {
  const [activeStep, setActiveStep] = useState(1);
  // Step 2 internal screens
  const [checkoutStep, setCheckoutStep] = useState(1);
  const [step2ActiveSection, setStep2ActiveSection] = useState(1);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional
    });
  }, [activeStep, checkoutStep, step2ActiveSection]);

  const [giftData, setGiftData] = useState();
  const [billingAddrress, setBillingAddress] = useState("");

  const [shippingAddrress, setShippingAddress] = useState("");
  const [sameShippingAddress, setSameShippingAddress] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState("");

  const [hasGiftItems, setHasGiftItems] = useState(false);
  const [giftEntireOrder, setGiftEntireOrder] = useState(false);
  const [giftIndividualItems, setGiftIndividualItems] = useState(false);

  const [cartData, setCartData] = useState();
  const getAllData = async () => {
    let res = await getCartLuxury();
    if (res?.success) {
      setCartData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData();
  }, []);

  const [user, setUser] = useState();
  const getUserData = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUser(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);

 
  return (
    <>
      <section className="Cart">
        <CartSteps
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          checkoutStep={checkoutStep}
          setCheckoutStep={setCheckoutStep}
        />

        <div className="custom_container">
          {/* STEP 1 */}
          {activeStep === 1 && (
            <Step_1
              getAllData={getAllData}
              cartData={cartData}
              setActiveStep={setActiveStep}
              setCheckoutStep={setCheckoutStep}
            />
          )}

          {/* STEP 2 - Screen 1 */}
          {/* {activeStep === 2 && checkoutStep === 1 && (
            <Step_2 setCheckoutStep={setCheckoutStep} />
          )} */}

          {/* STEP 2 - Screen 2 */}
          {activeStep === 2 && checkoutStep === 2 && (
            <Step_2_1
              user={user}
              setCheckoutStep={setCheckoutStep}
              setActiveStep={setActiveStep}
              step2ActiveSection={step2ActiveSection} // ✅ PASS
              setStep2ActiveSection={setStep2ActiveSection}
              giftData={giftData}
              setGiftData={setGiftData}
              shippingAddrress={shippingAddrress}
              setShippingAddress={setShippingAddress}
              billingAddrress={billingAddrress}
              setBillingAddress={setBillingAddress}
              sameShippingAddress={sameShippingAddress}
              setSameShippingAddress={setSameShippingAddress}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              hasGiftItems={hasGiftItems}
              setHasGiftItems={setHasGiftItems}
              giftEntireOrder={giftEntireOrder}
              setGiftEntireOrder={setGiftEntireOrder}
              giftIndividualItems={giftIndividualItems}
              setGiftIndividualItems={setGiftIndividualItems}
              cartData={cartData}
            />
          )}

          {/* STEP 3 */}
          {activeStep === 3 && (
            <Step_3
              giftData={giftData}
              user={user}
              paymentMethod={paymentMethod}
              cartData={cartData}
              shippingAddrress={shippingAddrress}
              billingAddrress={billingAddrress}
              setActiveStep={setActiveStep} // ✅ PASS THIS
              goBackToPayment={() => {
                setActiveStep(2); // go Step 2
                setCheckoutStep(2); // open Step_2_1
                setStep2ActiveSection(3); // open Payment section
              }}
            />
          )}
        </div>
      </section>
    </>
  );
}

export default Cart;
